import React, { useCallback, useState } from 'react';

import { connect } from 'react-redux';

import ReservationBarView from './ReservationBar.view';

import * as fromApp from '../../store/app';

import { OrderType } from 'app/enums/order-types';
import { IShuttle } from 'app/models/shuttle';
import { DestinationForm } from './ByDestination/ByDestination.model';
import { ByLineForm } from './ByLine/ByLine.model';
import { SearchType } from './ReservationBar.model';

interface PropsFromState {
  reservationBarDefaultTab: OrderType | null;
  shuttleSearchType: SearchType[] | null;
  maxPassengers: number;
  isDisabled: boolean;
}

interface Props extends PropsFromState {
  className?: string;
  initialValuesDestination?: DestinationForm | null;
  onSubmitLine: (values: ByLineForm, shuttleType: 'simple' | 'fixable', shuttle: IShuttle) => void;
  onSubmitDestination: (values: DestinationForm, orderType: OrderType | null) => void;
}

const ReservationBar: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [returnDateVisibility, setReturnDateVisibility] = useState<boolean>(false);
  const [searchTypesVisible, setSearchTypesVisible] = useState<boolean>(true);
  const [orderTypeState, setSearchTypeState] = useState<OrderType | null>(props.reservationBarDefaultTab);
  const [searchType, setAutoCompleteType] = useState<SearchType | null>(
    props.shuttleSearchType && props.shuttleSearchType.length != 0 ? props.shuttleSearchType[0] : SearchType.Destination,
  );

  const [passengersState, setPassengersState] = useState<number>(1);

  const onSelectedTab = useCallback(
    (tab: OrderType) => {
      setSearchTypeState(() => tab);
      setSearchTypesVisible(() => tab === OrderType.Shuttle);
      setReturnDateVisibility(() => tab !== OrderType.Shuttle);
    },
    [setReturnDateVisibility, setReturnDateVisibility, searchTypesVisible],
  );

  return (
    <ReservationBarView
      className={props.className}
      maxPassengers={props.maxPassengers}
      passengersCount={passengersState}
      onPassengerCount={(value: number) => setPassengersState(() => value)}
      initialValuesDestination={props.initialValuesDestination}
      orderTypeState={orderTypeState}
      returnDateVisibility={returnDateVisibility}
      selectedShuttleSearchType={searchType}
      shuttleSearchType={props.shuttleSearchType}
      searchTypesVisible={searchTypesVisible}
      onSubmitLine={props.onSubmitLine}
      onSubmitDestination={(values: DestinationForm) => props.onSubmitDestination(values, orderTypeState)}
      onSelectedTab={onSelectedTab}
      onSelectAutoCompleteType={(type: SearchType) => setAutoCompleteType(() => type)}
      isDisabled={props.isDisabled}
    ></ReservationBarView>
  );
};

ReservationBar.displayName = 'ReservationBar';
ReservationBar.defaultProps = {};

const mapStateToProps = (state: fromApp.AppState): PropsFromState => {
  return {
    reservationBarDefaultTab: state.settings.specs?.reservationBar.defaultTab || null,
    shuttleSearchType: state.settings.specs?.reservationBar.shuttleSearchType || null,
    maxPassengers: state.settings.supplierDetails?.pax || state.settings.specs?.maxSeats || 1,
    isDisabled: state.settings.supplierDetails?.name?.toLowerCase() === 'exo',
  };
};

export default connect(mapStateToProps)(ReservationBar);
